var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mt-1" },
    [
      _c("b-card-text", { staticClass: "mb-25" }, [
        _vm._v(" " + _vm._s(_vm.supplier ? _vm.supplier.name : "") + " "),
      ]),
      _c("b-card-text", { staticClass: "mb-25" }, [
        _vm._v(" " + _vm._s(_vm.supplier ? _vm.supplier.email : "") + " "),
      ]),
      _c("b-card-text", { staticClass: "mb-25" }, [
        _vm._v(" " + _vm._s(this.getAddress) + " "),
      ]),
      _c("b-card-text", { staticClass: "mb-25" }, [
        _vm._v(
          " " + _vm._s(_vm.supplier ? _vm.supplier.phoneNumber : "") + " "
        ),
      ]),
      _c("b-card-text", { staticClass: "mb-0" }, [
        _vm._v(
          " " + _vm._s(_vm.supplier ? _vm.supplier.contactPerson : "") + " "
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }